import { mutator } from 'satcheljs';
import { UnsubscribeResponseType, onAfterUnsubscribe, UnsubscribeSourceType, } from 'owa-brands-subscription';
export default mutator(onAfterUnsubscribe, function (actionMessage) {
    if (actionMessage.unsubscribeSourceType === UnsubscribeSourceType.Infobar &&
        actionMessage.responseType === UnsubscribeResponseType.Success &&
        actionMessage.completedCallback) {
        actionMessage.completedCallback();
    }
});
//# sourceMappingURL=onAfterUnsubscribeFromInfobar.js.map